import { createContext } from "react";
import {skill} from "../Components/Skills/Skill";
import English from '.././Languages/english.json';
import { projectType } from "../Components/Projects/Project";

type job = {
    name: string,
    img: string,
    date: string,
    position: string,
    color: string,
    information: string,
}

type coordinates = {
    x: number,
    y: number,
    z: number,
}

type positions = {
    default: coordinates,
    moved?: coordinates,
}

type contact = {
    name: string,
    svg: string,
    link: string,
    description: string,
    style: {background: string, color: string},
    button: string,
}

export type LanguageType = {
    id: string,
    navbar: {
        buttons: string[],
    }
    scrollText: string,
    crystal:{
        hi: string,
        dev: string,
        im: string,
        texts: string[],
        positions: {
            hiText: positions,
            nameText: positions,
            crystalObj: positions,
            imText: positions & {inRange: coordinates, outOfRange: coordinates},
            devText: positions,
            textGroup: positions,
        }
    },
    aboutMe: string[],
    skills: {
        title: string,
        categories: string[],
        tooltip: string,
        skills: skill[],
    },
    experience:{
        title: string,
        future: string,
        past: string,
        transformPast: string,
        jobs: job[],
    },
    projects: {
        title : string,
        personalButton: string,
        collaborativeButton: string,
        visitText: string,
        modalCategories: string[],
        showMoreButton: string,
        categories: {
            personalProjects: projectType[],
            collaborativeProjects: projectType[],
        }
    },
    contact:{
        title: string,
        contacts: contact[],
    },
    footer:{
        made: string[],
        source: string,
        credits: string,
        copyright: string,
    },
    start:{
        title: string,
        checkbox: string,
        button: string,
    }
    credits:{
        title: string,
        icons: string,
        sounds: string,
    }
}


type LanguageContextType = {
    language: LanguageType,
    setLanguage: React.Dispatch<React.SetStateAction<LanguageType>>
}

const iLanguageContextState = {
    language: English,
    setLanguage: () => {}
}

const LanguageContext = createContext<LanguageContextType>(iLanguageContextState)

export default LanguageContext;